import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-head-column__name desktop"
}
const _hoisted_2 = {
  key: 0,
  class: "table-head-column__price--ab"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "select-btn-desktop"
}

import AgilaInfoBlock from "frontend-component-templates/src/components/agilaInfoBlock.vue";
import AgilaButton from "frontend-component-templates/src/components/agilaButton.vue";

import { Product } from "../../classes/product";

interface Props {
  product?: Product;
  selectedDate?: Date;
  liability: boolean;
  defaultProduct: number;
  forceMobile?: boolean;
  index?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableColumnHeadComponent',
  props: {
    product: { default: undefined },
    selectedDate: { default: undefined },
    liability: { type: Boolean, default: false },
    defaultProduct: { default: undefined },
    forceMobile: { type: Boolean, default: false },
    index: { default: 0 }
  },
  emits: ["selectProduct"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-head-column-con", {
      noBorderRadius: _ctx.defaultProduct === props.index + 1,
    }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["table-head-column__name", { mobile: !props.forceMobile }])
    }, _toDisplayString(props.product.getDisplayNameMobile()), 3),
    (!props.forceMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(props.product.getDisplayNameDesktop()), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["table-head-column__price", { 'display-none': !props.product.price }])
    }, [
      (props.product.price)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!props.product.final)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "ab"))
              : _createCommentVNode("", true),
            (props.liability)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (props.product.id === 6)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("3,30 € ")
                      ], 64))
                    : _createCommentVNode("", true),
                  (props.product.id === 7)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("4,40 € ")
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(" " + props.product.getDisplayPrice() + " "), 1)
                ], 64)),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "mtl.", -1)),
            (props.liability)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (props.product.id === 6)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, " statt 6,60 € "))
                    : _createCommentVNode("", true),
                  (props.product.id === 7)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, " statt 8,80 € "))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    (props.product.price)
      ? (_openBlock(), _createBlock(AgilaButton, {
          key: 1,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('selectProduct'))),
          class: _normalizeClass('lre_' + props.product.id),
          ariaLabel: "Tarif wählen",
          yellow: true
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass({ 'select-btn-mobile': !props.forceMobile })
            }, _toDisplayString(props.liability ? "Hinzufügen" : "Wählen"), 3),
            (!props.forceMobile)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.liability ? "Hinzufügen" : "Tarif wählen"), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]))
      : (_openBlock(), _createBlock(AgilaInfoBlock, {
          key: 2,
          "show-icon": false,
          small: true
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.product.getErrorMessage(props.selectedDate)), 1)
          ]),
          _: 1
        }))
  ], 2))
}
}

})